import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { Modal } from "react-bootstrap";

const WarningPopup = ({ closePopup }) => {
  return (
    <Modal show={true} id="prescription-popup">
      <Modal.Body>
        <>
          <div className="prescription-detail">
            <div className="close-btn">
              <FontAwesomeIcon icon={faTimesCircle} onClick={closePopup} />
            </div>
            <div className="inner-section">
              <div className="row">
                <div className="col-md-12">
                  <h2 className="heading">
                    Prices listed are current and subject to change at the time
                    of purchase.
                  </h2>
                </div>
              </div>
            </div>
          </div>
        </>
      </Modal.Body>
    </Modal>
  );
};
export default WarningPopup;
